module.exports = __webpack_public_path__ + "cc0a6c0d92c97ca106546f12ab1b41d0.fbx";